export default "/images/logo.svg?0b0f24dc15de39710ee4303d1977fe0c";